module.exports = __webpack_public_path__ + "img/hontai_VanilaWhite.7df296bd.png";